import { render, staticRenderFns } from "./vText.vue?vue&type=template&id=53803dea&"
import script from "./vText.vue?vue&type=script&lang=js&"
export * from "./vText.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/nisems/front/nisbos-front-admin/project/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('53803dea')) {
      api.createRecord('53803dea', component.options)
    } else {
      api.reload('53803dea', component.options)
    }
    module.hot.accept("./vText.vue?vue&type=template&id=53803dea&", function () {
      api.rerender('53803dea', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "ls-form/components/saas/vText.vue"
export default component.exports